import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
export function TermsPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-[#0a0a0a] pt-24" data-id="element-563" data-mp="25b5z12i2wb94">
      <section className="border-b border-white/10 py-16 sm:py-24" data-id="element-564" data-mp="2k6lvfe64sj8o">
        <div className="container mx-auto max-w-6xl px-6 md:px-12" data-id="element-565" data-mp="2f790e653w5v0">
          <motion.div initial={{
          opacity: 0,
          y: 14
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          ease: [0.22, 1, 0.36, 1]
        }} className="grid gap-8 lg:grid-cols-[1fr_auto] lg:items-end" data-id="element-566" data-mp="2f5xx07fkp04f">
            <div className="max-w-3xl" data-id="element-567" data-mp="2xy8vzq73wdx9">
              <p className="eyebrow" data-id="element-568" data-mp="3bxhzpqe4lfkc">Información legal</p>
              <h1 className="mt-5 text-4xl font-medium tracking-[-0.055em] text-white sm:text-6xl" data-id="element-569" data-mp="3by1g32o4nvw9">
                Términos y Condiciones
              </h1>
            </div>
            <p className="border-l border-white/10 pl-5 text-xs leading-relaxed text-neutral-500 lg:max-w-[185px]" data-id="element-570" data-mp="2vo94ukajuwhw">
              Última actualización:{' '}
              {new Date().toLocaleDateString('es-ES', {
              month: 'long',
              year: 'numeric'
            })}
            </p>
          </motion.div>
        </div>
      </section>

      <section className="section-shell border-b border-white/10" data-id="element-571" data-mp="3em1x8snjro11">
        <div className="container mx-auto max-w-5xl px-6 md:px-12" data-id="element-572" data-mp="3eltj6xfouco9">
          <motion.article initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.08,
          ease: [0.22, 1, 0.36, 1]
        }} className="mx-auto max-w-3xl border-x border-t border-white/10" aria-label="Contenido de los términos y condiciones" data-id="element-573" data-mp="3imlt7swdwlll">
            <section className="border-b border-white/10 px-6 py-8 sm:px-10 sm:py-10" data-id="element-574" data-mp="3cmz4fhewgqom">
              <h2 className="text-xl font-medium tracking-[-0.025em] text-white" data-id="element-575" data-mp="37onuz7sioi6x">
                1. Objeto
              </h2>
              <p className="mt-5 text-sm leading-relaxed text-neutral-300 sm:text-[15px]" data-id="element-576" data-mp="3medbqbd3eusb">
                Los presentes Términos y Condiciones regulan el uso de los
                servicios ofrecidos por Growthly LLC (en adelante, "Growthly" o
                "la Agencia") a través de su sitio web, así como las condiciones
                de contratación de los servicios de diseño, desarrollo web y
                creación de ecosistemas digitales para empresas.
              </p>
            </section>

            <section className="border-b border-white/10 px-6 py-8 sm:px-10 sm:py-10" data-id="element-577" data-mp="490cqryynrgx">
              <h2 className="text-xl font-medium tracking-[-0.025em] text-white" data-id="element-578" data-mp="2az6hi6nalruo">
                2. Servicios contratados
              </h2>
              <p className="mt-5 text-sm leading-relaxed text-neutral-300 sm:text-[15px]" data-id="element-579" data-mp="2614y1klyfqio">
                Growthly ofrece servicios integrales de presencia digital, que
                incluyen, pero no se limitan a:
              </p>
              <ul className="mt-5 space-y-3 border-l border-white/15 pl-4 text-sm leading-relaxed text-neutral-400 sm:text-[15px]" data-id="element-580" data-mp="brq65a1dnbul">
                <li data-id="element-581" data-mp="gozzh0rw07np">Diseño y desarrollo de páginas web profesionales.</li>
                <li data-id="element-582" data-mp="2qa3jogt0e0x">Creación de menús y cartas digitales interactivas.</li>
                <li data-id="element-583" data-mp="6rvdb0y1kc6w">Gestión integral y mantenimiento técnico continuo.</li>
                <li data-id="element-584" data-mp="6q0rlkey4g1r">Consultoría estratégica digital.</li>
              </ul>
              <p className="mt-5 text-sm leading-relaxed text-neutral-300 sm:text-[15px]" data-id="element-585" data-mp="3ozb0qzxoh0kw">
                Las especificaciones exactas de cada proyecto se detallarán en
                la propuesta comercial aceptada por el cliente.
              </p>
            </section>

            <section className="border-b border-white/10 px-6 py-8 sm:px-10 sm:py-10" data-id="element-586" data-mp="1s5q2kb10kjd3">
              <h2 className="text-xl font-medium tracking-[-0.025em] text-white" data-id="element-587" data-mp="3o94if9tisyqp">
                3. Precio y forma de pago
              </h2>
              <p className="mt-5 text-sm leading-relaxed text-neutral-300 sm:text-[15px]" data-id="element-588" data-mp="3jab45f6et3ph">
                El precio de nuestro servicio estándar de ecosistema digital es
                de <strong className="font-medium text-white" data-id="element-589" data-mp="3a7s5765qvb8i">350€</strong>{' '}
                (impuestos incluidos, salvo indicación contraria). Se trata de
                un{' '}
                <strong className="font-medium text-white" data-id="element-590" data-mp="30iiadijinegp">
                  pago único por adelantado
                </strong>{' '}
                que incluye la creación de la página web y su gestión y
                mantenimiento completos, sin cuotas ni cargos posteriores.
              </p>
              <p className="mt-5 text-sm leading-relaxed text-neutral-300 sm:text-[15px]" data-id="element-591" data-mp="2mjscw1ssbcrt">
                El pago se realiza mediante transferencia bancaria a los datos
                facilitados al confirmar el proyecto. Los trabajos comienzan una
                vez confirmada la transferencia.
              </p>
            </section>

            <section className="border-b border-white/10 px-6 py-8 sm:px-10 sm:py-10" data-id="element-592" data-mp="11zn96vzxjwmk">
              <h2 className="text-xl font-medium tracking-[-0.025em] text-white" data-id="element-593" data-mp="171mcy6zl0vk1">
                4. Plazos de entrega
              </h2>
              <p className="mt-5 text-sm leading-relaxed text-neutral-300 sm:text-[15px]" data-id="element-594" data-mp="1azk259tcrhnf">
                Los plazos de entrega se acordarán de forma individualizada con
                cada cliente tras la confirmación del pago. Growthly se
                compromete a cumplir los plazos establecidos, siempre y cuando
                el cliente proporcione el material y la información necesaria
                (textos, imágenes, accesos) en los tiempos requeridos. Los
                retrasos imputables al cliente modificarán proporcionalmente la
                fecha de entrega final.
              </p>
            </section>

            <section className="border-b border-white/10 px-6 py-8 sm:px-10 sm:py-10" data-id="element-595" data-mp="12wvgh1n2edn3">
              <h2 className="text-xl font-medium tracking-[-0.025em] text-white" data-id="element-596" data-mp="xz2bgbxhzpoe">
                5. Obligaciones del cliente
              </h2>
              <p className="mt-5 text-sm leading-relaxed text-neutral-300 sm:text-[15px]" data-id="element-597" data-mp="1cmx7a16sya5p">
                El cliente se compromete a:
              </p>
              <ul className="mt-5 space-y-3 border-l border-white/15 pl-4 text-sm leading-relaxed text-neutral-400 sm:text-[15px]" data-id="element-598" data-mp="jy9e7jftaghl">
                <li data-id="element-599" data-mp="f0zr4afwagwx">Proporcionar información veraz y completa.</li>
                <li data-id="element-600" data-mp="szz5mp9p1ffd">
                  Entregar los materiales necesarios para el desarrollo del
                  proyecto en los plazos acordados.
                </li>
                <li data-id="element-601" data-mp="p08jiyv43nh6">
                  Abonar los importes correspondientes en las fechas
                  estipuladas.
                </li>
                <li data-id="element-602" data-mp="20dsrod8xi32x">
                  Garantizar que posee los derechos de autor o licencias de uso
                  de cualquier material (imágenes, textos, logotipos)
                  proporcionado a la Agencia.
                </li>
              </ul>
            </section>

            <section className="border-b border-white/10 px-6 py-8 sm:px-10 sm:py-10" data-id="element-603" data-mp="1xymb46u58yk2">
              <h2 className="text-xl font-medium tracking-[-0.025em] text-white" data-id="element-604" data-mp="22xh4g2pqm5if">
                6. Propiedad intelectual
              </h2>
              <p className="mt-5 text-sm leading-relaxed text-neutral-300 sm:text-[15px]" data-id="element-605" data-mp="2qo300uik1xbj">
                Una vez abonado el 100% del importe del proyecto, el cliente
                adquiere los derechos de explotación sobre el producto final
                entregado (página web, diseños). Growthly se reserva el derecho
                de mostrar el proyecto en su portfolio, casos de éxito y
                material promocional, salvo que se firme un acuerdo de
                confidencialidad (NDA) específico.
              </p>
            </section>

            <section className="border-b border-white/10 px-6 py-8 sm:px-10 sm:py-10" data-id="element-606" data-mp="1eaczhpqeodm9">
              <h2 className="text-xl font-medium tracking-[-0.025em] text-white" data-id="element-607" data-mp="1ec7ll7deybrx">
                7. Responsabilidad
              </h2>
              <p className="mt-5 text-sm leading-relaxed text-neutral-300 sm:text-[15px]" data-id="element-608" data-mp="15h9odo38gcus">
                Growthly no se hace responsable de las caídas de servidores de
                terceros (hosting), problemas con proveedores de dominio, o
                cambios en los algoritmos de plataformas externas (Google, Meta)
                que puedan afectar al rendimiento del ecosistema digital una vez
                entregado.
              </p>
            </section>

            <section className="border-b border-white/10 px-6 py-8 sm:px-10 sm:py-10" data-id="element-609" data-mp="1j9puixrfkqzx">
              <h2 className="text-xl font-medium tracking-[-0.025em] text-white" data-id="element-610" data-mp="1jbtytgt8rs0q">
                8. Cancelaciones y reembolsos
              </h2>
              <p className="mt-5 text-sm leading-relaxed text-neutral-300 sm:text-[15px]" data-id="element-611" data-mp="7t98glldfc43">
                El cliente tiene derecho a la devolución íntegra del pago (350€)
                si decide cancelar el proyecto antes de la presentación de la
                primera propuesta de diseño. Una vez presentados los primeros
                trabajos o propuestas, el importe no será reembolsable en su
                totalidad, ya que cubre los gastos operativos y de consultoría
                inicial.
              </p>
            </section>

            <section className="px-6 py-8 sm:px-10 sm:py-10" data-id="element-612" data-mp="gj7t5m9upvq8">
              <h2 className="text-xl font-medium tracking-[-0.025em] text-white" data-id="element-613" data-mp="ledfgm761ceu">
                9. Legislación aplicable
              </h2>
              <p className="mt-5 text-sm leading-relaxed text-neutral-300 sm:text-[15px]" data-id="element-614" data-mp="ve49ynvq7rex">
                Estos Términos y Condiciones se rigen por la legislación
                española. Para la resolución de cualquier controversia que
                pudiera derivarse de la prestación de los servicios, las partes
                se someten a los Juzgados y Tribunales competentes.
              </p>
            </section>
          </motion.article>
        </div>
      </section>
    </div>;
}